module.exports = __webpack_public_path__ + "img/lighthouse.d745de3a.svg";